import { render, staticRenderFns } from "./GroupChangeDialog.vue?vue&type=template&id=809ec2f0&scoped=true&"
import script from "./GroupChangeDialog.vue?vue&type=script&lang=js&"
export * from "./GroupChangeDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupChangeDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GroupChangeDialog.vue?vue&type=style&index=1&id=809ec2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809ec2f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VCheckbox,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VVirtualScroll})
